import React from 'react';
import { StarIcon } from 'lucide-react';
type Testimonial = {
  quote: string;
  author: string;
  role?: string;
  avatar?: string;
};
type TestimonialsProps = {
  testimonials: Testimonial[];
  title?: string;
  subtitle?: string;
  background?: 'white' | 'blush';
};
export function Testimonials({
  testimonials,
  title = 'What instructors are saying',
  subtitle,
  background = 'white'
}: TestimonialsProps) {
  const bg = background === 'white' ? 'bg-white' : 'bg-blush';
  return <section aria-label={title} className={`w-full text-ink ${bg}`} data-id="element-257" data-mp="3205z4pbyd3k3">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-258" data-mp="321zb8k5c4fzh">
        <div className="text-center" data-id="element-259" data-mp="2x1utkqsoxf7o">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold-deep" data-id="element-260" data-mp="2x2w5exhj65qg">
            Instructor to instructor
          </p>
          <h2 className="mt-3 font-display font-semibold text-plum text-3xl sm:text-5xl" data-id="element-261" data-mp="v9or9rdnlu65">
            {title}
          </h2>
          {subtitle && <p className="mx-auto mt-4 max-w-2xl text-sm text-ink-soft" data-id="element-262" data-mp="q896m0fe1poa">
              {subtitle}
            </p>}
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-263" data-mp="m5kngsk6j1ej">
          {testimonials.map((item, i) => <figure key={i} className="rounded-3xl border border-cream-dark bg-white p-5 shadow-card" data-id="element-264" data-mp="78tub113mlxd" data-mpi={i}>
              <div className="flex items-center gap-2.5" data-id="element-265" data-mp="c8ol74kvjbif">
                {item.avatar ? <img src={item.avatar} alt={item.author} width={44} height={44} loading="lazy" className="h-11 w-11 rounded-full object-cover ring-2 ring-cream-dark" data-id="element-266" data-mp="zyiu5b22ofxe" /> : <span className="flex h-11 w-11 items-center justify-center rounded-full bg-plum font-display text-[13px] italic text-gold" data-id="element-267" data-mp="1ivk0p0b9yo3g">
                    {item.author.replace(/[^A-Za-z ]/g, '').split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase() || 'WB'}
                  </span>}
                <span className="flex gap-0.5" aria-label="Five out of five" data-id="element-268" data-mp="1ofhor2cni5i7">
                  {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-269" data-mp="1ej4vu6oxjvoi" />)}
                </span>
              </div>
              <blockquote className="mt-3 font-display text-[15px] italic leading-relaxed text-ink" data-id="element-270" data-mp="14u4uwhqvaq7o">
                {item.quote}
              </blockquote>
              <figcaption className="mt-4 text-xs text-ink-soft" data-id="element-271" data-mp="vsdo19klcdc8">
                <span className="block text-[13px] font-semibold not-italic text-plum" data-id="element-272" data-mp="vuq41h6sgdmn">
                  {item.author}
                </span>
                {item.role}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}